import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndexComponent } from './screens/index/index.component';
import { AuthGuardCanActivate } from './services/utilities/authentication.service';
import { ProductionGuardService } from './services/guard/production-guard.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AuthoriseComponent } from './screens/login/authorise/authorise/authorise.component';
import { tenant } from 'src/tenants/tenant';
import { environment } from 'src/environments/environment';

const ENV = environment;

const routes: Routes = [
    {
        path: '',
        redirectTo: ENV.environment.toLowerCase() === 'dev' ? 'login' : tenant.landingRedirect,
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: () => import('./screens/login/login.module').then(m => m.LoginScreenModule)
    },
    {
        path: 'account',
        loadChildren: () => import('./screens/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
    },
    {
        path: 'accessDenied', pathMatch: 'full',
        loadChildren: () => import('./components/organisms/access-denied/access-denied.module').then(m => m.AccessDeniedOrganismModule)
    },
    {
        path: 'pageNotFound', pathMatch: 'full',
        loadChildren: () => import('./components/organisms/access-denied/access-denied.module').then(m => m.AccessDeniedOrganismModule)
    },
    {
        path: 'hypotheek',
        canActivate: [AuthGuardCanActivate],
        loadChildren: () => import('./components/molecules/tools-mortgage/tools-mortgage.module').then(m => m.ToolsMortgageMoleculeModule)
    },
    {
        path: 'overview',
        canActivate: [AuthGuardCanActivate],
        loadChildren: () => import('./screens/overview/overview.routes').then(m => m.overviewRoutes)
    },
    {
        path: 'details',
        canActivate: [AuthGuardCanActivate],
        loadChildren: () => import('./screens/details/details.routes').then(m => m.detailsRoutes)
    },
    {
        path: 'tools',
        canActivate: [AuthGuardCanActivate],
        loadChildren: () => import('./screens/tools/tools.module').then(m => m.ToolsModule)
    },
    {
        path: 'unsubscribe',
        loadChildren: () => import('./screens/unsubscribe/interest-mailing/interest-mailing.module').then(m => m.InterestMailingUnsubscribeScreenModule)
    },
    { path: 'authorize', component: AuthoriseComponent },
    { path: 'index', component: IndexComponent, canActivate: [ProductionGuardService] },
    { path: '**', redirectTo: '/pageNotFound' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {}), DragDropModule],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
